<hf-custom-button
  type="button"
  icon="menu"
  iconPos="right"
  class="button-primary btn-lrg for-phone-show"
  (onClick)="templateService.openSidebar()"
>
</hf-custom-button>
